import { Button, Input, Menu, MenuItemProps, Popup, Image, List, Icon, InputOnChangeData } from 'semantic-ui-react'
import { _SPT_BUDGET_TABS } from './ServiceProviderBudgetListContainer'
import sort from '../../../../../assets/svg/noun_sorting.svg'
import search from '../../../../../assets/svg/search_icon.svg'
import React, { useState } from 'react'
import { ICostSearch, ICostSorting, ICostsSortColumn } from '../../../types/directAndPassTroughCosts'
import { useStateFromProp } from '../../../../../hooks/useStateFromProps'
import { IProject } from '../../../types/project'

interface Props {
  project: IProject
  activeItem: string
  searchCostsValue: ICostSearch
  sortCosts: ICostSorting
  setActiveBudgetTab: (tab: string) => void
  searchCosts: (filter: ICostSearch) => void
  exportProjectDirectCosts: (projectId: number, params: Record<string, string>) => void
  setSortCosts: (sorting: ICostSorting) => void
}

const SPBudgetCategoryTabs = (props: Props): JSX.Element => {

  const {
    project,
    activeItem,
    searchCostsValue,
    sortCosts,
    setActiveBudgetTab,
    searchCosts,
    exportProjectDirectCosts,
    setSortCosts
  } = props

  const [searchLoading, setSearchLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useStateFromProp(searchCostsValue.search ? searchCostsValue.search : '')
  const [timer, setTimer] = useState<number>(0)

  const handleItemClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, data: MenuItemProps): void => {
    if (data && data.name) {
      if (data.name.toLowerCase() !== activeItem) {
        setActiveBudgetTab(data.name.toLowerCase())
      }
    }
  }

  const handleClearSearch = (): void => {
    searchCosts({ search: '' })
    setSearchQuery('')
  }

  const handleOptionSelect = (key: string): void => {
    if (key === 'export') {
      exportProjectDirectCosts(+project.id, { type: 'csv', serializer: 'budget' })
    }
  }

  const renderAdditionalDropdown = (): JSX.Element => {
    return (
      <List style={{ width: '5.2rem' }}>
        <List.Item content='Export CSV' onClick={() => handleOptionSelect('export')} style={{ cursor: 'pointer' }} />
      </List>
    )
  }

  const renderExportButton = (): JSX.Element => {
    return (
      <Popup
        trigger={
          <Button
            size='small'
            secondary={true}
            icon={<Icon name='ellipsis horizontal' style={{ fontSize: '1.2rem' }} />}
            style={{ padding: '0', borderRadius: '8px', width: '2.3rem', height: '2.3rem' }}
          />
        }
        style={{ marginLeft: '0.5rem' }}
        content={renderAdditionalDropdown()}
        on='click'
        position='bottom left'
      />
    )
  }

  const renderSearchIcon = (): JSX.Element => {
    if (searchQuery === '') {
      return <Image src={search} style={{ left: '-100%', top: '-2%', padding: '0.5rem' }} />
    }
    return <Icon name='close' link={true} onClick={handleClearSearch} />
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void => {
    clearTimeout(timer)
    const _timer = window.setTimeout(() => {
      setSearchLoading(false)
    }, 300)
    searchCosts({ search: data.value })
    setTimer(_timer)
    setSearchLoading(true)
    setSearchQuery(data.value)
  }

  const renderSortDropdown = (): JSX.Element => {
    return (
      <List>
        <List.Item content={'Phase'} onClick={e => handleSortSelect(e, 'phase')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'phase' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Department'} onClick={e => handleSortSelect(e, 'department')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'department' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Completion'} onClick={e => handleSortSelect(e, 'completion')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'completion' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Overall'} onClick={e => handleSortSelect(e, 'overall')} style={{ cursor: 'pointer', backgroundColor: sortCosts.clustering === 'overall' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
      </List>
    )
  }

  const handleSortSelect = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, _sort: ICostSorting['clustering']): void => {
    setSortCosts({ clustering: _sort, column: {} as ICostsSortColumn })
  }

  const budgetTabs = (): JSX.Element => {
    return (
      <Menu secondary>
        {_SPT_BUDGET_TABS.map(tab => {
          return (
            <Menu.Item
              key={tab.name}
              name={tab.name}
              active={activeItem === tab.key}
              onClick={(e, data) => handleItemClick(e, data)}
              style={{
                border: activeItem === tab.key ? '1px solid #08D6A1' : '1px solid #BEC8C3',
                color: activeItem === tab.key ? '#08D6A1' : '#747678',
                borderRadius: '.5rem',
                height: '2.3rem',
                background: '#FFFFFF'
              }}
            />
          )
        })}
      </Menu>
    )
  }

  const renderInputAndButtons = (): JSX.Element => {
    return (
      <React.Fragment>
        <div style={{ display: 'flex' }}>
          <Input
            loading={searchLoading}
            className='search-input-medium'
            size='small'
            style={{ width: '12.14rem', height: '2.14rem', paddingRight: '0.5rem' }}
            icon={renderSearchIcon()}
            iconPosition='left'
            placeholder='Search'
            onChange={(e, data) => handleSearch(e, data)}
            value={searchQuery}
          />
          <Popup
            basic
            trigger={
              <Button
                secondary={true}
                content={
                  <Image
                    size='mini'
                    src={sort}
                  />
                }
                style={{ height: '2.3rem', padding: '0 4%', borderRadius: '.57rem', width: '2.3rem' }}
              />
            }
            content={renderSortDropdown()}
            on='click'
            position='bottom right'
          />
          {renderExportButton()}
        </div>
      </React.Fragment>
    )
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {budgetTabs()}
      {renderInputAndButtons()}
    </div>
  )
}

export default SPBudgetCategoryTabs